import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import EventPage from './Events/EventPage';
import InternalResourcePage from './InternalResources/InternalResourcesPage';
import ExternalResourcePage from './ExternalResources/ExternalResourcesPage';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (

    <MainLayout scope={'solarys'} websiteLabel={"solarys-asso.fr"}>
      <EventPage isActive={navigationContext.activeAppKey === 'syevent'} />
      <InternalResourcePage isActive={navigationContext.activeAppKey === 'syinternalresource'} />
      <ExternalResourcePage isActive={navigationContext.activeAppKey === 'syexternalresource'} />

    </MainLayout>
  );
}

export default Home;
